import { Link } from "react-router-dom";
import { trackUrl } from "../lib/api";
import { platformLabel } from "../lib/platforms";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, span = "default" }) {
  const spanCls =
    span === "hero"
      ? "md:col-span-8 md:row-span-2"
      : span === "wide"
      ? "md:col-span-6"
      : span === "tall"
      ? "md:col-span-4 md:row-span-2"
      : "md:col-span-4";

  return (
    <article
      data-testid={`product-card-${product.id}`}
      className={`grid-card group relative flex flex-col ${spanCls} overflow-hidden`}
    >
      <Link to={`/product/${product.id}`} className="block">
        <div className={`relative overflow-hidden bg-[#EBEBEA] ${span === "hero" ? "aspect-[16/10]" : "aspect-[4/5]"}`}>
          <img
            src={product.image_url}
            alt={product.title}
            className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            loading="lazy"
          />
          <span
            data-testid={`platform-badge-${product.id}`}
            className="absolute top-4 left-4 px-2.5 py-1 bg-[#0A0A0A] text-white text-[10px] uppercase tracking-[0.18em] font-semibold"
          >
            {platformLabel(product.platform)}
          </span>
        </div>
      </Link>
      <div className="p-5 lg:p-6 flex flex-col flex-1">
        <p className="overline text-[#666]">{product.category}</p>
        <Link to={`/product/${product.id}`}>
          <h3 className={`font-display font-black tracking-tighter mt-2 leading-[1.05] ${span === "hero" ? "text-3xl md:text-4xl" : "text-xl md:text-2xl"}`}>
            {product.title}
          </h3>
        </Link>
        <div className="mt-auto pt-5 flex items-center justify-between">
          <span className="text-base font-semibold">
            {product.currency === "USD" ? "$" : product.currency} {product.price.toFixed(2)}
          </span>
          <a
            data-testid={`buy-now-${product.id}`}
            href={trackUrl(product.id)}
            target="_blank"
            rel="noopener noreferrer sponsored"
            className="inline-flex items-center gap-1.5 text-sm font-semibold uppercase tracking-wider text-[#0A0A0A] hover:text-[#E53935] transition-colors"
          >
            Buy <ArrowUpRight className="w-4 h-4" strokeWidth={1.8} />
          </a>
        </div>
      </div>
    </article>
  );
}
